var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { GenericModalTypes, GenericModalWithIconContent } from '../../shared';
import { useTranslation } from 'react-i18next';
import { getApiErrorTranslationKeys, OperationType } from '@amzn/atoz-shiftapp-utilities';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Text } from '@amzn/atoz-web/Text';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var AcceptVtoModalError = function (_a) {
    var close = _a.close, error = _a.error;
    var t = useTranslation().t;
    var errorTranslations = getApiErrorTranslationKeys(error, OperationType.ACCEPT_VTO);
    return (React.createElement(GenericModalWithIconContent, { dataTestId: "AcceptVtoModalError", onClose: close, mainText: t(errorTranslations[0].title), buttons: [
            React.createElement(StyledButton, { key: "1", variant: ButtonVariant.Primary, onClick: close, dataTestId: "AcceptVtoModalErrorDoneButton" }, t('shift_management_features_VtoAcceptModalError_buttonText'))
        ], type: GenericModalTypes.danger },
        React.createElement(Text, { textAlign: "center" }, t(errorTranslations[0].body))));
};
var StyledButton = styledWithTheme(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1;
